import script from "./NumberDecoderModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberDecoderModule.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__